module.exports = __webpack_public_path__ + "img/monk.9b769f05.png";